import { writable } from "svelte/store";

export const campaignDetailStore  = writable({});
export const campaignAdEditStore  = writable({});